export default __webpack_public_path__ + "static/media/Showroom_hover.fc2f8078.png";